import {
  type ISavedEmailSection,
  savedEmailSectionSchema,
} from "@redotech/redo-marketing-templates-common/saved-email-section";
import * as z from "zod";

export const getSavedEmailSections = {
  name: "getSavedEmailSections" as const,
  input: z.object({}),
  output: z.array(savedEmailSectionSchema as ISavedEmailSection),
};
